/*
 * @Author: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @Date: 2026-01-27 19:52:57
 * @LastEditors: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @LastEditTime: 2026-02-12 16:30:01
 * @FilePath: /knit-web/src/locale/zh-CN/tool.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
export default {
  tool: {
    publishAsTool: '发布为工具',
    publish: '发布',
    name: '名称',
    description: '描述',
    avatar: '头像',
    iconPlaceholder: 'Emoji',
    backgroundColor: '背景颜色',
    namePlaceholder: '请输入名称',
    nameRequired: '名称不能为空',
    descriptionRequired: '描述不能为空',
    selectCategory: '请选择分类',
    categoryRequired: '分类不能为空',
    version: '版本号',
    toolVersion: '工具版本',
    mustTestRun: '必须先测试运行再发布',
    submitToMarketplace: '上架到市场',
    creditsPerUse: '每次使用可获得 100 积分！',
    submitAsTemplateEarn: '提交为模板工具即可开始赚取积分。',
    selectFromWorkflowLogs: '从工作流日志选择',
    logInput: '日志输入',
    workflowNamePlaceholder: '工作流名称',
    workflowDescPlaceholder: '工作流描述',
    inputDescPlaceholder: '变量含义描述',
    toolType: '工具类型',
    toolInput: '工具输入',
    toolOutput: '工具输出',
    testInput: '输入示例',
    tags: '标签',
    author: '作者',
    changeLog: '更新动态',
    required: '必填',
    optional: '选填',
    requiredLabel: '是否必填',
    template: '工作流模板 (Template)',
    subFlow: '子工作流 (SubFlow)',
    useTemplate: '使用模板',
    templateDesc:
      'Template类型工具被其他用户复制到工作空间时，表现为一条工作流，其他用户可以直接创建为一个新工作流',
    useTemplateConfirmTitle: '使用模板确认',
    useTemplateConfirmContent: '确定要使用模板 "{name}" 吗？',
    addToWorkflow: '添加到工作流',
    eachCopyEarn: '每次复制可获得 100 积分',
    officialDoc: '发布模板官方说明文档',
    validateIssues: '验证问题',
    noTestRun: '当前工作流未经测试运行',
    goToTestRun: '去测试运行',
    publishSuccess: '发布成功',
    publishFailed: '发布失败',
    backToStudio: '返回工作流开发台',
    manageInTools: '去管理工具',
    inputName: '参数名',
    inputMethod: '设定方式',
    inputDesc: '描述',
    outputName: '参数名',
    outputDesc: '描述',
    versionPlaceholder: '默认 v0.1.0',
    setting: '设置',
    frontend: '前端输入',
    updateTool: '更新工具',
    tool: '工具',
    selectTool: '选择工具',
    selectToolPlaceholder: '请选择要更新的工具',
    selectToolFirst: '请先选择要更新的工具',
    latestPublished: '最新发布',
    selectToolToUpdate: '请选择要更新的工具',
    changeLogPlaceholder: '请输入更新动态（选填）',
    versionError: '版本号必须大于当前版本 ({current})',
    updateSuccess: '更新成功',
    manageTools: '去管理工具',
    selectPublishType: '选择发布类型',
    createNewTool: '创建新工具',
    createNewToolDesc: '创建一个全新的工具',
    updateExistingTool: '更新已有工具',
    updateExistingToolDesc: '为已有工具创建新版本',
    noToolsAvailable: '暂无可用工具',
    workspaceRequired: '需要工作空间信息',
    fetchToolsFailed: '获取工具列表失败',
    selectTags: '请选择标签',
    useRunInput: '使用运行输入',
    allTags: '所有标签',
    searchPlaceholder: '搜索工具名称',
    noToolsFound: '未找到相关工具',
    noDescription: '暂无描述',
    updatedAt: '更新于',
    usageCount: '次使用',
    usageCountLabel: '使用次数',
    unpublish: '下架版本',
    publishConfirmTitle: '确认发布',
    publishConfirmContent: '确定要将工具 "{name}" 的最新版本发布到市场吗？',
    unpublishConfirmTitle: '确认下架',
    unpublishConfirmContent: '确定要下架工具 "{name}" 的当前版本吗？',
    unpublishSuccess: '下架成功',
    unpublishFailed: '下架失败',
    fetchFailed: '加载失败',
    status: {
      normal: '正常',
      disabled: '禁用',
    },
    latestVersion: '最新版本',
    publishedVersion: '已上架版本',
    versionHistory: '版本历史',
    manage: '管理',
    delete: '删除',
    deleteConfirmTitle: '确认删除',
    deleteConfirmContent: '确定要删除工具 "{name}" 吗？',
    category: '分类',
    versionNum: '版本号',
    createdAt: '创建时间',
    manifest: 'Manifest',
    toolUuid: '工具 UUID',
    tenantUuid: '租户 UUID',
    workspaceUuid: '工作空间 UUID',
    sourceWorkflowUuid: '源工作流 UUID',
    sourceWorkflowVersionNum: '源工作流版本',
    workflowUuid: '工作流 UUID',
    versionStatus: {
      draft: '未上架',
      pending: '审核中',
      published: '已上架',
      disabled: '已禁用',
    },
    type: {
      workflow_template: '工作流模板',
      workflow: '工作流',
    },
    currentVersionInfo: '当前版本信息',
    toolInfo: '工具信息',
    statusLabel: '状态',
    typeLabel: '类型',
    stateLabel: '状态',
  },
};
